/**
 * @module cercaliagl/AssertionError
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error}
 */
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    /**
     * @param {string} message Message
     * @param {*=} [params] Optional parameters
     */
    function AssertionError(message, params) {
        var _this = _super.call(this) || this;
        /**
         * @type {string}
         */
        _this.message = message;
        /**
         * @type {string}
         */
        _this.name = 'Cercalia API Error';
        if (params !== undefined) {
            /**
             * @type {*|undefined}
             */
            _this.extraParams = params;
        }
        return _this;
    }
    return AssertionError;
}(Error));
export function assert(assertion, message, params) {
    if (!assertion) {
        throw new AssertionError(message, params);
    }
}
export default AssertionError;
//# sourceMappingURL=AssertionError.js.map